// قائمة كاملة بجميع دول العالم ومقدماتها الدولية
export const countryCodes = [
  { code: '+93', country: 'Afghanistan', countryAr: 'أفغانستان' },
  { code: '+355', country: 'Albania', countryAr: 'ألبانيا' },
  { code: '+213', country: 'Algeria', countryAr: 'الجزائر' },
  { code: '+376', country: 'Andorra', countryAr: 'أندورا' },
  { code: '+244', country: 'Angola', countryAr: 'أنغولا' },
  { code: '+54', country: 'Argentina', countryAr: 'الأرجنتين' },
  { code: '+374', country: 'Armenia', countryAr: 'أرمينيا' },
  { code: '+61', country: 'Australia', countryAr: 'أستراليا' },
  { code: '+43', country: 'Austria', countryAr: 'النمسا' },
  { code: '+994', country: 'Azerbaijan', countryAr: 'أذربيجان' },
  { code: '+1242', country: 'Bahamas', countryAr: 'الباهاما' },
  { code: '+973', country: 'Bahrain', countryAr: 'البحرين' },
  { code: '+880', country: 'Bangladesh', countryAr: 'بنغلاديش' },
  { code: '+375', country: 'Belarus', countryAr: 'بيلاروسيا' },
  { code: '+32', country: 'Belgium', countryAr: 'بلجيكا' },
  { code: '+501', country: 'Belize', countryAr: 'بليز' },
  { code: '+229', country: 'Benin', countryAr: 'بنين' },
  { code: '+975', country: 'Bhutan', countryAr: 'بوتان' },
  { code: '+591', country: 'Bolivia', countryAr: 'بوليفيا' },
  { code: '+387', country: 'Bosnia', countryAr: 'البوسنة والهرسك' },
  { code: '+267', country: 'Botswana', countryAr: 'بوتسوانا' },
  { code: '+55', country: 'Brazil', countryAr: 'البرازيل' },
  { code: '+673', country: 'Brunei', countryAr: 'بروناي' },
  { code: '+359', country: 'Bulgaria', countryAr: 'بلغاريا' },
  { code: '+855', country: 'Cambodia', countryAr: 'كمبوديا' },
  { code: '+237', country: 'Cameroon', countryAr: 'الكاميرون' },
  { code: '+1', country: 'Canada', countryAr: 'كندا' },
  { code: '+56', country: 'Chile', countryAr: 'تشيلي' },
  { code: '+86', country: 'China', countryAr: 'الصين' },
  { code: '+57', country: 'Colombia', countryAr: 'كولومبيا' },
  { code: '+506', country: 'Costa Rica', countryAr: 'كوستاريكا' },
  { code: '+385', country: 'Croatia', countryAr: 'كرواتيا' },
  { code: '+53', country: 'Cuba', countryAr: 'كوبا' },
  { code: '+357', country: 'Cyprus', countryAr: 'قبرص' },
  { code: '+420', country: 'Czech Republic', countryAr: 'التشيك' },
  { code: '+45', country: 'Denmark', countryAr: 'الدنمارك' },
  { code: '+253', country: 'Djibouti', countryAr: 'جيبوتي' },
  { code: '+1809', country: 'Dominican Republic', countryAr: 'الدومينيكان' },
  { code: '+593', country: 'Ecuador', countryAr: 'الإكوادور' },
  { code: '+20', country: 'Egypt', countryAr: 'مصر' },
  { code: '+503', country: 'El Salvador', countryAr: 'السلفادور' },
  { code: '+372', country: 'Estonia', countryAr: 'إستونيا' },
  { code: '+251', country: 'Ethiopia', countryAr: 'إثيوبيا' },
  { code: '+679', country: 'Fiji', countryAr: 'فيجي' },
  { code: '+358', country: 'Finland', countryAr: 'فنلندا' },
  { code: '+33', country: 'France', countryAr: 'فرنسا' },
  { code: '+995', country: 'Georgia', countryAr: 'جورجيا' },
  { code: '+49', country: 'Germany', countryAr: 'ألمانيا' },
  { code: '+233', country: 'Ghana', countryAr: 'غانا' },
  { code: '+30', country: 'Greece', countryAr: 'اليونان' },
  { code: '+502', country: 'Guatemala', countryAr: 'غواتيمالا' },
  { code: '+509', country: 'Haiti', countryAr: 'هايتي' },
  { code: '+504', country: 'Honduras', countryAr: 'هندوراس' },
  { code: '+852', country: 'Hong Kong', countryAr: 'هونغ كونغ' },
  { code: '+36', country: 'Hungary', countryAr: 'المجر' },
  { code: '+354', country: 'Iceland', countryAr: 'آيسلندا' },
  { code: '+91', country: 'India', countryAr: 'الهند' },
  { code: '+62', country: 'Indonesia', countryAr: 'إندونيسيا' },
  { code: '+98', country: 'Iran', countryAr: 'إيران' },
  { code: '+964', country: 'Iraq', countryAr: 'العراق' },
  { code: '+353', country: 'Ireland', countryAr: 'أيرلندا' },
  { code: '+972', country: 'Israel', countryAr: 'إسرائيل' },
  { code: '+39', country: 'Italy', countryAr: 'إيطاليا' },
  { code: '+81', country: 'Japan', countryAr: 'اليابان' },
  { code: '+962', country: 'Jordan', countryAr: 'الأردن' },
  { code: '+7', country: 'Kazakhstan', countryAr: 'كازاخستان' },
  { code: '+254', country: 'Kenya', countryAr: 'كينيا' },
  { code: '+965', country: 'Kuwait', countryAr: 'الكويت' },
  { code: '+996', country: 'Kyrgyzstan', countryAr: 'قيرغيزستان' },
  { code: '+856', country: 'Laos', countryAr: 'لاوس' },
  { code: '+371', country: 'Latvia', countryAr: 'لاتفيا' },
  { code: '+961', country: 'Lebanon', countryAr: 'لبنان' },
  { code: '+218', country: 'Libya', countryAr: 'ليبيا' },
  { code: '+370', country: 'Lithuania', countryAr: 'ليتوانيا' },
  { code: '+352', country: 'Luxembourg', countryAr: 'لوكسمبورغ' },
  { code: '+60', country: 'Malaysia', countryAr: 'ماليزيا' },
  { code: '+960', country: 'Maldives', countryAr: 'المالديف' },
  { code: '+356', country: 'Malta', countryAr: 'مالطا' },
  { code: '+52', country: 'Mexico', countryAr: 'المكسيك' },
  { code: '+373', country: 'Moldova', countryAr: 'مولدوفا' },
  { code: '+377', country: 'Monaco', countryAr: 'موناكو' },
  { code: '+976', country: 'Mongolia', countryAr: 'منغوليا' },
  { code: '+382', country: 'Montenegro', countryAr: 'الجبل الأسود' },
  { code: '+212', country: 'Morocco', countryAr: 'المغرب' },
  { code: '+95', country: 'Myanmar', countryAr: 'ميانمار' },
  { code: '+977', country: 'Nepal', countryAr: 'نيبال' },
  { code: '+31', country: 'Netherlands', countryAr: 'هولندا' },
  { code: '+64', country: 'New Zealand', countryAr: 'نيوزيلندا' },
  { code: '+234', country: 'Nigeria', countryAr: 'نيجيريا' },
  { code: '+850', country: 'North Korea', countryAr: 'كوريا الشمالية' },
  { code: '+47', country: 'Norway', countryAr: 'النرويج' },
  { code: '+968', country: 'Oman', countryAr: 'عُمان' },
  { code: '+92', country: 'Pakistan', countryAr: 'باكستان' },
  { code: '+970', country: 'Palestine', countryAr: 'فلسطين' },
  { code: '+507', country: 'Panama', countryAr: 'بنما' },
  { code: '+595', country: 'Paraguay', countryAr: 'باراغواي' },
  { code: '+51', country: 'Peru', countryAr: 'بيرو' },
  { code: '+63', country: 'Philippines', countryAr: 'الفلبين' },
  { code: '+48', country: 'Poland', countryAr: 'بولندا' },
  { code: '+351', country: 'Portugal', countryAr: 'البرتغال' },
  { code: '+974', country: 'Qatar', countryAr: 'قطر' },
  { code: '+40', country: 'Romania', countryAr: 'رومانيا' },
  { code: '+7', country: 'Russia', countryAr: 'روسيا' },
  { code: '+250', country: 'Rwanda', countryAr: 'رواندا' },
  { code: '+966', country: 'Saudi Arabia', countryAr: 'السعودية' },
  { code: '+221', country: 'Senegal', countryAr: 'السنغال' },
  { code: '+381', country: 'Serbia', countryAr: 'صربيا' },
  { code: '+65', country: 'Singapore', countryAr: 'سنغافورة' },
  { code: '+421', country: 'Slovakia', countryAr: 'سلوفاكيا' },
  { code: '+386', country: 'Slovenia', countryAr: 'سلوفينيا' },
  { code: '+252', country: 'Somalia', countryAr: 'الصومال' },
  { code: '+27', country: 'South Africa', countryAr: 'جنوب أفريقيا' },
  { code: '+82', country: 'South Korea', countryAr: 'كوريا الجنوبية' },
  { code: '+211', country: 'South Sudan', countryAr: 'جنوب السودان' },
  { code: '+34', country: 'Spain', countryAr: 'إسبانيا' },
  { code: '+94', country: 'Sri Lanka', countryAr: 'سريلانكا' },
  { code: '+249', country: 'Sudan', countryAr: 'السودان' },
  { code: '+46', country: 'Sweden', countryAr: 'السويد' },
  { code: '+41', country: 'Switzerland', countryAr: 'سويسرا' },
  { code: '+963', country: 'Syria', countryAr: 'سوريا' },
  { code: '+886', country: 'Taiwan', countryAr: 'تايوان' },
  { code: '+992', country: 'Tajikistan', countryAr: 'طاجيكستان' },
  { code: '+255', country: 'Tanzania', countryAr: 'تنزانيا' },
  { code: '+66', country: 'Thailand', countryAr: 'تايلاند' },
  { code: '+216', country: 'Tunisia', countryAr: 'تونس' },
  { code: '+90', country: 'Turkey', countryAr: 'تركيا' },
  { code: '+993', country: 'Turkmenistan', countryAr: 'تركمانستان' },
  { code: '+256', country: 'Uganda', countryAr: 'أوغندا' },
  { code: '+380', country: 'Ukraine', countryAr: 'أوكرانيا' },
  { code: '+971', country: 'UAE', countryAr: 'الإمارات' },
  { code: '+44', country: 'United Kingdom', countryAr: 'المملكة المتحدة' },
  { code: '+1', country: 'United States', countryAr: 'الولايات المتحدة' },
  { code: '+598', country: 'Uruguay', countryAr: 'أوروغواي' },
  { code: '+998', country: 'Uzbekistan', countryAr: 'أوزبكستان' },
  { code: '+58', country: 'Venezuela', countryAr: 'فنزويلا' },
  { code: '+84', country: 'Vietnam', countryAr: 'فيتنام' },
  { code: '+967', country: 'Yemen', countryAr: 'اليمن' },
  { code: '+260', country: 'Zambia', countryAr: 'زامبيا' },
  { code: '+263', country: 'Zimbabwe', countryAr: 'زيمبابوي' }
];

// قائمة الدول للاستخدام في select
export const allCountries = countryCodes.map(item => ({
  value: item.country,
  label: `${item.country} - ${item.countryAr}`,
  code: item.code
}));
